"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_VITALS_PERF_OBSERVER_TYPES = void 0;
/**
 * Map of Web Vitals metrics and the `PerformanceObserver` API entry types that
 * are required to be supported by the browser in order to measure them.
 *
 * @see
 *   [GitHub/web-vitals: observe.ts#L40](https://github.com/GoogleChrome/web-vitals/blob/v3.3.1/src/lib/observe.ts#L40)
 */
const WEB_VITALS_PERF_OBSERVER_TYPES = {
    /** [GitHub/web-vitals: onCLS.ts#L105](https://github.com/GoogleChrome/web-vitals/blob/v3.3.1/src/onCLS.ts#L105) */
    CLS: 'layout-shift',
    /** [GitHub/web-vitals: onFID.ts#L71](https://github.com/GoogleChrome/web-vitals/blob/v3.3.1/src/onFID.ts#L71) */
    FID: 'first-input',
    /** [GitHub/web-vitals: onINP.ts#L203](https://github.com/GoogleChrome/web-vitals/blob/v3.3.1/src/onINP.ts#L203) */
    INP: 'event',
    /** [GitHub/web-vitals: onLCP.ts#L80](https://github.com/GoogleChrome/web-vitals/blob/v3.3.1/src/onLCP.ts#L80) */
    LCP: 'largest-contentful-paint',
};
exports.WEB_VITALS_PERF_OBSERVER_TYPES = WEB_VITALS_PERF_OBSERVER_TYPES;
/**
 * Returns `true` if the given Web Vitals metric is supported by the current
 * browser (i.e., if the browser supports the required APIs to measure the
 * metric). Returns `false` if the metric is not supported.
 *
 * @note You probably don't need to use this function directly! Just use the
 *   cached `ACTIVE_WEB_VITALS` constant instead.
 * @see
 *   [MDN: supportedEntryTypes](https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/supportedEntryTypes_static)
 */
const isWebVitalsMetricActive = metric => {
    var _a;
    // TTFB is a special case b/c it uses the `PerformanceNavigationTiming` API
    // instead of the `PerformanceObserver` API like the other Web Vitals. See
    // - https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
    // - https://github.com/GoogleChrome/web-vitals/blob/v3.3.1/src/lib/getNavigationEntry.ts#L42
    if (metric === 'TTFB') {
        const perfNavEntry = typeof (performance === null || performance === void 0 ? void 0 : performance.getEntriesByType) === 'function' &&
            ((_a = performance.getEntriesByType('navigation')) === null || _a === void 0 ? void 0 : _a[0]);
        return Boolean(perfNavEntry);
    }
    // Look up the `PerformanceObserver` entry type for the given metric
    const type = WEB_VITALS_PERF_OBSERVER_TYPES[metric];
    try {
        // Return if the entry type is supported by the browser
        return PerformanceObserver.supportedEntryTypes.includes(type);
    }
    catch (e) {
        // Return false if `PerformanceObserver` itself is not supported at all
    }
    return false;
};
exports.default = isWebVitalsMetricActive;
